import { Link } from 'react-router-dom';
import InfoText from '../atoms/InfoText';

type SellerPageBreadcrumbsProps = {
  dashboardLabel: string;
  listLabel: string;
  currentLabel: string;
  listPath?: string;
};

export default function SellerPageBreadcrumbs({
  dashboardLabel,
  listLabel,
  currentLabel,
  listPath = '/sellers',
}: SellerPageBreadcrumbsProps) {
  return (
    <div className="text-sm text-gray-500 flex items-center gap-1 flex-wrap">
      <Link to="/" className="hover:text-gray-900 dark:hover:text-gray-200 transition-colors">
        <InfoText text={dashboardLabel} />
      </Link>
      <InfoText text="/" />
      <Link to={listPath} className="hover:text-gray-900 dark:hover:text-gray-200 transition-colors">
        <InfoText text={listLabel} />
      </Link>
      <InfoText text="/" />
      <InfoText className="text-gray-900 font-medium dark:text-gray-300" text={currentLabel} />
    </div>
  );
}
